import { render, staticRenderFns } from "./SaleRecoveryFilter.vue?vue&type=template&id=2cd8fdde&scoped=true&"
import script from "./SaleRecoveryFilter.vue?vue&type=script&lang=js&"
export * from "./SaleRecoveryFilter.vue?vue&type=script&lang=js&"
import style0 from "./SaleRecoveryFilter.vue?vue&type=style&index=0&id=2cd8fdde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8fdde",
  null
  
)

export default component.exports